import { combineReducers } from 'redux';
import App from '@tt/redux/app/reducer';
import ThemeSwitcher from '@tt/redux/themeSwitcher/reducer';
import LanguageSwitcher from '@tt/redux/languageSwitcher/reducer';
import { createReducer } from '../utils/reducer';
import * as AuthService from '../services/auth/reducer';

import * as CommonService from '../services/common/reducer';

// User Level Details
import * as UserDetailService from '../services/userLevelDetails/reducer';

//Dashboards Data
import * as OeeGridDashboardService from '../services/dashboards/oee/reducer';
import * as CSuitDashboardService from '../services/dashboards/CSuitDashboard/reducer';
import * as factoryEfficiencyService from '../services/dashboards/factoryEfficiency/reducer';
import * as globalDashboardService from '../services/dashboards/globalDashboard/reducer';
import * as OeeEquipmentDashboardService from '../services/dashboards/oeeEquipment/reducer';
import * as FactoryAreaService from '../services/dashboards/live_factory/reducer';
import * as VisionDashboardService from '../services/dashboards/vision/reducer';
import * as VisionEquipmentDashboardService from '../services/dashboards/visionEquipment/reducer';
import * as VisionOLEDashboardService from '../services/dashboards/visionOLEDashboard/reducer';
import * as ContactTracingDashboardService from '../services/dashboards/visionContactTracing/reducer';
import * as SilosGridDashboardService from '../services/dashboards/silos/reducer';
import * as SilosAssignmentDashboardService from '../services/dashboards/silosAssignment/reducer';
import * as SilosEquipmentDashboardService from '../services/dashboards/silosEquipment/reducer';
import * as EnergyGridDashboardService from '../services/dashboards/energy/reducer';
import * as JobGridDashboardService from '../services/dashboards/job/reducer';
import * as MaintenanceDashboardService from '../services/dashboards/maintenance/reducer';
import * as QualityAssuranceDashboardService from '../services/dashboards/qualityAssurance/reducer';
import * as AuxiliaryGridDashboardService from '../services/dashboards/auxiliary/reducer';

// Reports Data
import * as ReportService from '../services/reports/reducer';

//Operations Data
import * as JobHistoryOperationService from '../services/operations/job_history/reducer';
import * as LineJobHistoryOperationService from '../services/operations/line_job_history/reducer';
import * as JobImportHistoryOperationService from '../services/operations/job_import_history/reducer';
import * as UnassignedJobsOperationService from '../services/operations/unassigned_jobs/reducer';
import * as DowntimeOperationService from '../services/operations/downtime/reducer';
import * as RejectionOperationService from '../services/operations/rejection/reducer';
import * as OperatorSkillOperationService from '../services/operations/operator_skills/reducer';
import * as UnidentifiedOperatorOperationService from '../services/operations/unidentified_operator/reducer';
import * as JobOperatorOperationService from '../services/operations/job_operators/reducer';
import * as ProductionOperationService from '../services/operations/production/reducer';
import * as ToolAvgCycleTimeOperationService from '../services/operations/avg_cycletime/reducer';
import * as ERPEquipmentMappingOperationService from '../services/operations/erp_equipment_mapping/reducer';
import * as ERPJobImportLogsOperationService from '../services/operations/erp_job_import_logs/reducer';

// Maintenance Data
import * as MaintenanceSerive from '../services/maintenance/reducer';

// Quality Assurance Service
import * as QualityAssuranceService from '../services/qualityAssurance/reducer';

//Master Data
import * as FactoryService from '../services/master/factories/reducer';
import * as OperatorService from '../services/master/operators/reducer';
import * as ShiftService from '../services/master/shifts/reducer';
import * as ProductService from '../services/master/products/reducer';
import * as DepartmentService from '../services/master/departments/reducer';
import * as RawMaterialService from '../services/master/raw_materials/reducer';
import * as EquipmentService from '../services/master/equipments/reducer';
import * as AuditLogsService from '../services/master/audit_logs/reducer';
import * as ToolService from '../services/master/tools/reducer';
import * as CrewsService from '../services/master/crews/reducer';
import * as GroupService from '../services/master/groups/reducer';
import * as ProductAttributeService from '../services/master/productAttribute/reducer';
import * as LineService from '../services/master/lines/reducer';
import * as PositionService from '../services/master/positions/reducer';
import * as JobTypeService from '../services/master/job_types/reducer';
import * as JobTitlesService from '../services/master/job_titles/reducer';
import * as DowntimeCategoryService from '../services/master/downtime_categories/reducer';
import * as DonwntimeReasonService from '../services/master/downtime_reasons/reducer';
import * as FactoryAreasService from '../services/master/factory_areas/reducer';
import * as InterestRegionService from '../services/master/interest_region/reducer';
import * as RejectionReasonService from '../services/master/rejection_reasons/reducer';
import * as lineJobReconciliationService from '../services/dashboards/lineJobReconciliation/reducer';
import * as RejectionTypeService from '../services/master/rejection_types/reducer';
import * as visionAIProjectService from '../services/master/visionProject/reducer';
import * as PrismaticService from '../services/dashboards/prismatic/reducer';
import * as DowntimeReasonHighlightsService from '../services/master/downtime_reasons_highlights/reducer';

export default combineReducers({
  App,
  ThemeSwitcher,
  LanguageSwitcher,
  services: combineReducers({
    auth: createReducer(AuthService),
    common: createReducer(CommonService),
    userDetail: createReducer(UserDetailService),
    globalDashboard: createReducer(globalDashboardService),
    oeeGridDashboard: createReducer(OeeGridDashboardService),
    cSuitDashboardService: createReducer(CSuitDashboardService),
    factoryEfficiency: createReducer(factoryEfficiencyService),
    oeeEquipmentDashboard: createReducer(OeeEquipmentDashboardService),
    silosDashboard: createReducer(SilosGridDashboardService),
    silosAssignmentDashboard: createReducer(SilosAssignmentDashboardService),
    silosEquipmentDashboard: createReducer(SilosEquipmentDashboardService),
    visionDashboard: createReducer(VisionDashboardService),
    visionEquipmentDashboard: createReducer(VisionEquipmentDashboardService),
    visionOLEDashboard: createReducer(VisionOLEDashboardService),
    contactTracingDashboard: createReducer(ContactTracingDashboardService),
    energyGridDashboard: createReducer(EnergyGridDashboardService),
    jobGridDashboard: createReducer(JobGridDashboardService),
    maintenanceDashboard: createReducer(MaintenanceDashboardService),
    qaComplaintDashboardService: createReducer(QualityAssuranceDashboardService),
    qaEightdProcessDashboardService: createReducer(QualityAssuranceDashboardService),
    auxiliaryDashboardService: createReducer(AuxiliaryGridDashboardService),
    reports: createReducer(ReportService),
    jobHistoryOperation: createReducer(JobHistoryOperationService),
    lineJobHistoryOperation: createReducer(LineJobHistoryOperationService),
    JobImportHistoryOperation: createReducer(JobImportHistoryOperationService),
    unassignedJobsOperation: createReducer(UnassignedJobsOperationService),
    erpEquipmentMappingOperation: createReducer(ERPEquipmentMappingOperationService),
    erpJobImportLogsOperations: createReducer(ERPJobImportLogsOperationService),
    downtimeOperation: createReducer(DowntimeOperationService),
    rejectionOperation: createReducer(RejectionOperationService),
    operatorSkillOperation: createReducer(OperatorSkillOperationService),
    unidentifiedOperatorsOperation: createReducer(UnidentifiedOperatorOperationService),
    jobOperatorsOperation: createReducer(JobOperatorOperationService),
    productionOperation: createReducer(ProductionOperationService),
    toolAvgCycleTimeOperation: createReducer(ToolAvgCycleTimeOperationService),
    maintenance: createReducer(MaintenanceSerive),
    qualityAssurance: createReducer(QualityAssuranceService),
    factory: createReducer(FactoryService),
    group: createReducer(GroupService),
    line: createReducer(LineService),
    position: createReducer(PositionService),
    department: createReducer(DepartmentService),
    shift: createReducer(ShiftService),
    equipment: createReducer(EquipmentService),
    auditLogs: createReducer(AuditLogsService),
    product: createReducer(ProductService),
    tool: createReducer(ToolService),
    crews: createReducer(CrewsService),
    operator: createReducer(OperatorService),
    rawMaterial: createReducer(RawMaterialService),
    jobType: createReducer(JobTypeService),
    jobTitles: createReducer(JobTitlesService),
    downtimeCategory: createReducer(DowntimeCategoryService),
    downtimeReason: createReducer(DonwntimeReasonService),
    rejectionReason: createReducer(RejectionReasonService),
    factoryArea: createReducer(FactoryAreaService),
    factoryAreas: createReducer(FactoryAreasService),
    interestRegion: createReducer(InterestRegionService),
    lineJobReconciliation: createReducer(lineJobReconciliationService),
    rejectionType: createReducer(RejectionTypeService),
    prismatic: createReducer(PrismaticService),
    visionProject: createReducer(visionAIProjectService),
    productAttribute: createReducer(ProductAttributeService),
    downtimeReasonHighlights: createReducer(DowntimeReasonHighlightsService),
  }),
});
